import { SortDirection } from '@lx/shared/types';

export function isSortDirection(varToCheck: unknown): varToCheck is SortDirection {
  return varToCheck === 'asc' || varToCheck === 'desc';
}
